import { Components } from '@/api/generated/api';
import { SubscriptionStatus } from '@/api/generated/api.enum';

export function hasSeatsAvailableForBillingStatus(
  billingStatus: Components.Schemas.BillingStatusDto | undefined,
  seatType: Components.Schemas.SeatType,
): boolean {
  if (!billingStatus) return true;
  if (!billingStatus.isBillingActive) return true;
  if (billingStatus.isTrialActive || billingStatus.status === SubscriptionStatus.trialing) return true;

  const activeSeatManagedProducts = billingStatus.products.filter(
    (product) => product.isCurrentlyActive && product.supportsSeats && product.seatType === seatType,
  );

  if (!activeSeatManagedProducts.length) return true;

  const { capacity, used } = activeSeatManagedProducts.reduce(
    (acc, product) => ({
      capacity: acc.capacity + (product.seatUsage?.capacity ?? product.seats ?? 0),
      used: acc.used + (product.seatUsage?.used ?? 0),
    }),
    { capacity: 0, used: 0 },
  );

  return used < capacity;
}

export function canCreateBillingOfferFromStatus(
  billingStatus: Components.Schemas.BillingStatusDto | undefined,
): boolean {
  if (!billingStatus) return false;
  if (billingStatus.pendingInvoice || billingStatus.isInvoicePastDue) return false;

  const unresolvedStatuses: Components.Schemas.SubscriptionStatus[] = [
    SubscriptionStatus.past_due,
    SubscriptionStatus.unpaid,
    SubscriptionStatus.incomplete,
    SubscriptionStatus.paused,
  ];
  if (unresolvedStatuses.includes(billingStatus.status)) return false;
  if (billingStatus.hasActivePlan) return false;

  return true;
}

export function shouldShowBillingStatusCtaRow(
  billingStatus: Components.Schemas.BillingStatusDto | undefined,
  canCreateBillingOffer: boolean,
): boolean {
  if (!billingStatus || !canCreateBillingOffer) return false;
  if (billingStatus.pendingOffer || billingStatus.pendingInvoice || billingStatus.isInvoicePastDue) return false;
  if (billingStatus.hasActivePlan) return false;
  if (billingStatus.hasAnySubscriptionHistory && !billingStatus.isTrialActive) return false;

  return true;
}
